import * as validations from "./validations";
import maskValidation from "./maskValidation";
export default {
  ...validations,
  maskValidation
};
//# sourceMappingURL=index.js.map